import React from "react";
import { useOptInStore } from "../store";
import { ConfirmationFormValues } from "../types";
import { ConfirmationFormik } from "./confirmation-formik";

interface ConfirmationStepProps {
  onSubmit: (values: ConfirmationFormValues) => Promise<void>;
}

export function ConfirmationStep(props: ConfirmationStepProps) {
  const error = useOptInStore((state) => state.confirmationError);
  const phoneNumber = useOptInStore((state) => state.phoneNumber);
  const formattedPhoneNumber = phoneNumber?.replace(
    /(\d)(\d{3})(\d{3})(\d{4})/,
    "+$1 ($2) $3-$4"
  );

  return (
    <div>
      <div className="space-y-2">
        <h1 className="display-medium text-body">Almost Done!</h1>
        <p className="body text-body">
          A 6-digit verification code was sent to {formattedPhoneNumber}. Please
          enter it below to confirm sign up.
        </p>
      </div>
      <div className="mt-4">
        <ConfirmationFormik error={error} onSubmit={props.onSubmit} />
      </div>
    </div>
  );
}
